/* eslint-disable */
const getConfig = require("next/config").default;
let config = {};
if (process.env.NODE_ENV !== "test") {
  const { publicRuntimeConfig } = getConfig();
  config = publicRuntimeConfig;
}
module.exports = config; // allow the config to be used on server as well!
